exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-component='reset'] .reset-signature {\n  width: 100%;\n}\n[data-component='reset'] .reset-signature .form-reset-signature {\n  width: 220px;\n  display: inline-block;\n}\n[data-component='reset'] [data-component='signature'] {\n  margin: 40px 0 55px;\n}\n[data-component='reset'] [data-component='virtual-num-pad'] {\n  margin: 0 110px 0 0;\n  opacity: 0;\n  visibility: hidden;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-digital-signature/reset/reset.component.styl
// module id = ../../../../../src/app/master/change-digital-signature/reset/reset.component.styl
// module chunks = main